// Note: This is exported but not injectable. This is on purpose as
// it's not intended to be a singleton and doesn't need to be tied
// specifically to Angular.

export class CancellationToken {
    private _isCancelled: boolean = false;
    get isCancelled(): boolean {
      return this._isCancelled;
    }
  
    constructor(private source: CancellationTokenSource) {
      let boundCallback = this.onSourceCancelled.bind(this);
      source.notify(() => boundCallback());
    }
  
    private onSourceCancelled() {
      this._isCancelled = true;
      if (this.source.throwOnCancel) {
        throw 'A request to cancel has been invoked';
      }
    }
  }
  
  export class CancellationTokenSource {
    private _token: CancellationToken;
    get token(): CancellationToken {
      return this._token;
    }
  
    throwOnCancel: boolean = false;
  
    callbacks: (() => any)[] = [];
  
    constructor() {
      this._token = new CancellationToken(this);
    }
  
    notify(callback: () => any) {
      this.callbacks.push(callback);
    }
  
    cancel() {
      for (let callback of this.callbacks) {
        callback();
      }
    }
  }
  